import React from 'react';

import { useAutoNavigate } from '@betterment/js-runtime';
import { Button } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../../features/track';
import { addAccountUrl } from '../../../Shared/addAccountUrl';
import { urlBuilder } from '../../../Shared/urlBuilder';
import { AccountRecommendationOptionQuery } from '../graphql/query.accountRecommendationOption.generated';

type AccountRecommendationOption = NonNullable<AccountRecommendationOptionQuery['accountRecommendationOption']>;
type AccountRecommendation = NonNullable<AccountRecommendationOption['recommendation']>;
type Option = AccountRecommendation['productOnboardingOption'];

export const OpenAccountButton: React.FC<{ option: Option; disabled?: boolean }> = ({ option, disabled }) => {
  const navigate = useAutoNavigate();
  const url = (() => {
    if (option.__typename === 'GoalCreationOption') {
      return addAccountUrl({ product_category: option.legacyProductCategory });
    }

    if (option.__typename === 'CheckingAccountCreationOption') {
      return urlBuilder.getAppCheckingAbout.absolute();
    }

    if (option.__typename === 'Solo401kOnboardingOption') {
      const pc = option.legacyProductCategory;
      return urlBuilder.appAdviceInitiationFlow.absolute({ signup_intent: pc, product_category: pc });
    }

    return null;
  })();

  if (!url) return null;

  return (
    <SambaAutoLink to={url}>
      <Button
        variant="solidPrimary"
        disabled={disabled}
        onClick={() => {
          trackClick({ name: 'OpenAccount', module: 'AccountRecommendation', recommendation: option.name });
          void navigate(url);
        }}
      >
        Open this account
      </Button>
    </SambaAutoLink>
  );
};
